export function getParams(state) {
    return state.params
}

export function sublinesList(state) {
    return state.sublinesList;
}


// WEBPACK FOOTER //
// ./src/modules/sublines/getters.js